import React, { useEffect } from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import NextButton from "../components/NextButton";
import { setGroup } from "../redux/actions";
import { ROUTES } from "../utils/constants";
import { updateStats } from "../utils/helpers";
import felicidadesVideo from "../assets/video-felicidades.mp4";
import { useVideoWithSound } from "../hooks/useVideoWithSound";

function Congratulations({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const group = useSelector((state) => state.group);

	const { videoRef } = useVideoWithSound({
		autoPlay: true,
		volume: 1,
	});

	useEffect(() => {
		if (group) {
			dispatch(
				setGroup({
					...group,
					lastVisited: ROUTES.RESULTS,
					finished: true,
				})
			);
			updateStats({
				...group,
				lastVisited: ROUTES.RESULTS,
				finished: true,
			});
		}
	}, []);

	return (
		<div className="h-100">
			<div
				className="container-fluid h-100 d-flex justify-content-center align-items-center position-relative overflow-hidden"
				style={{
					minHeight: "100%",
					backgroundColor: "#1a1a24",
				}}
				onClick={() => {
					updateStats({
						...group,
						finished: true,
						lastVisited: ROUTES.RESULTS,
					});
					navigate(ROUTES.RESULTS);
				}}
			>
				<video
					ref={videoRef}
					className="final-scene-bg-video"
					autoPlay
					playsInline
					preload="auto"
					muted
				>
					<source src={felicidadesVideo} type="video/mp4" />
				</video>

				<div
					className="row h-50 position-relative"
					style={{ zIndex: 1 }}
				>
					<div className="col-12">
						<div
							className="text-center py-5"
							style={{
								backgroundColor: "#FFFFFFAA",
								borderRadius: "10px",
								padding: "20px",
							}}
						>
							<div className="txt42 txtRed bold">
								¡Felicidades, sinfonía completada!​
							</div>
							<div className="txtRed txt24">
								<div className="mt-4">
									Y ahora,{" "}
									<span className="bold">
										¿quieren conocer su puntuación?
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					className="px-5"
					style={{ position: "absolute", right: "0", bottom: "7%", zIndex: 10 }}
				>
					<div onClick={(e) => e.stopPropagation()}>
						<NextButton
							text={"VER RESULTADOS"}
							navigateTo={ROUTES.RESULTS}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}

export default injectIntl(Congratulations);
